import React, { useEffect } from 'react'
import get from 'lodash.get'
import { Container } from 'react-bootstrap'
import TitleDescription from 'components/molecules/TitleDescription'
import dataGa from 'helpers/dataGa'

const Faq = (props) => {
  const { data, user, refs } = props
  const entity = get(data, 'route.entity') || { content: [] }
  const title = get(entity, 'title')
  const description = get(entity, 'body.value')

  useEffect(() => {
    dataGa(entity.dataGa)
  }, [])

  return (
    <>
      <Container className="page-faqs section-spacing-first">
        <Container>
          <TitleDescription title={title} description={description} first={true} refs={refs} />
        </Container>
      </Container>
    </>
  )
}

export default Faq
